import { InvoiceStatus } from '../enums/invoice-status.enum';

export const quartersAvailable = 4;

export const invoiceStatusMap = new Map<InvoiceStatus, string>()
    .set(InvoiceStatus.NotPaidYet, 'payment-scheduled')
    .set(InvoiceStatus.WaitingForInvoiceOrApproval, 'waiting')
    .set(InvoiceStatus.InvoicePaid, 'paid');
